module.exports = __webpack_public_path__ + "static/media/team_01.d474a1be.jpg";